import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { TimePeriodSegmentedVizExternalProps } from '../../types';
import {
  TimePeriodSegmentedTableViewActions,
  TimePeriodSegmentedTableViewState,
} from './types';

export const useTimePeriodSegmentedBarChartStateManager = (
  // We might need more props later, but I am not sure
  externalProps: TimePeriodSegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  TimePeriodSegmentedTableViewState,
  TimePeriodSegmentedTableViewActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: false,
      enableStack: false,
      enableLabels: false,
      enableLegend: false,
      enableSortOrder: true,
      enableTableView: false,
      enableExport: false,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
